export { VpTranscriptionBadge } from './VpTranscriptionBadge';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTranscriptionBadge/index.js